// 查看证书
// import {downloadIamge} from './downloadImage';
export  default {
    data(){
        return{
            // 证书是否可点击：
            isClickCertificate:false,
            previewModalVisbile:false,
            previewUrl:'',
            showOverlay:false,
        }
    },
    methods:{
          // 是否需要实名认证 
        // 训练营里面，我的证书只传参数businessId, 我的证书列表里面，点击证书详情，只需要传id
        // 判断 isAuthentication  userAuthenStatus  ,
        // 1.isAuthentication 为0代表证书不需要实名 直接展示证书
        // 2.isAuthentication 为1代表证书 需要实名，
        // 判断 userAuthenStatus  是0  代表用户未实名，此时需要让用户去实名
        // userAuthenStatus是1代表用户已经实名 直接展示证书
        checkCertificate(key,value,isclikC,train){
            this.$api.certificate.getCertificateWithCheck(key,value).then(res=>{
                if(res.data){
                    this.isClickCertificate = true;
                    this.previewUrl = res.data.url;
                    if(res.data.isAuthentication == 0 || (res.data.isAuthentication==1 && res.data.userAuthenStatus ==1)){ //不需要实名或者需要实名并且已实名
                        if(isclikC == 'btn'){
                            this.showOverlay = true;
                        }
                    }else{
                        this.showOverlay = false;
                        // 进行实名认证
                        if(isclikC == 'btn'){
                            this.$router.push({
                                path: '/idcard'
                            })
                        }
                    }
                }else{
                    this.isClickCertificate = false;
                    if(train=='train' && isclikC=='btn'){
                        this.$toast({
                            message:'你还没有获得证书，请继续努力！',
                            className:'def'
                        })
                        return 
                    }
                }   
            })
        },
        showModel(url) {
            this.$nextTick(() => {
                this.previewUrl = url;
            })
            this.showOverlay = true;
        },
        handleCloseAuth(){
            this.authGuideModalVisbile = false;
        },
        handleClosePreview(){
            this.previewModalVisbile = false;
        },
    },
    created() {
    },
}